import axios from "axios";

/**
 * Pick the API base URL.
 *
 * In preview, REACT_APP_BACKEND_URL and the browser origin are the same host,
 * so we use it as-is.
 *
 * In production with a custom domain (e.g. peptideseries.com), the env var
 * may still point to the Emergent-native host (peptide-clinic.emergent.host).
 * Hitting that from a different host triggers cross-origin / cookie failures
 * ("Network Error" on login). Detect that case and fall back to the current
 * browser origin so /api/* requests stay same-origin.
 */
function resolveBackendUrl() {
  const fromEnv = process.env.REACT_APP_BACKEND_URL;
  if (typeof window === "undefined") return fromEnv || "";
  const browserOrigin = window.location.origin;
  if (!fromEnv) return browserOrigin;
  try {
    const envHost = new URL(fromEnv).host;
    const curHost = window.location.host;
    return envHost === curHost ? fromEnv : browserOrigin;
  } catch {
    return browserOrigin;
  }
}

export const BACKEND_URL = resolveBackendUrl();
export const API = `${BACKEND_URL}/api`;

/**
 * Resolve a stored image URL. If it's already absolute, return as-is.
 * If it's host-relative (e.g. "/api/media/..."), prepend the current backend
 * base so it works both in preview and under a custom domain.
 */
export function resolveImageUrl(value) {
  if (!value) return value;
  if (/^https?:\/\//i.test(value)) return value;
  if (value.startsWith("/")) return `${BACKEND_URL}${value}`;
  return value;
}

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export default api;

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (detail == null) return err?.message || "Something went wrong.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  }
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
